import { cn } from "../../lib/utils";
import type { ReactNode } from "react";

interface KpiCardProps {
  label: string;
  value: string;
  target: string;
  progress: number; // 0-100
  accentColor?: string;
  icon?: ReactNode;
  className?: string;
}

export function KpiCard({ label, value, target, progress, accentColor, icon, className }: KpiCardProps) {
  const clampedProgress = Math.max(0, Math.min(100, progress));
  return (
    <div
      className={cn(
        "rounded-[var(--radius-lg)] border border-[var(--color-border-stroke)] bg-[var(--color-bg-surface)] p-[var(--spacing-4)]",
        className,
      )}
    >
      <div className="flex items-center gap-[var(--spacing-2)] mb-[var(--spacing-1)]">
        {icon && (
          <span className="text-[var(--color-text-muted)] shrink-0">{icon}</span>
        )}
        <span className="text-[14px] text-[var(--color-text-secondary)]">{label}</span>
      </div>
      <div className="flex items-baseline gap-[var(--spacing-1)]">
        <span
          className="text-[14px] font-semibold tabular-nums"
          style={{ color: accentColor ?? "var(--color-text-primary)" }}
        >
          {value}
        </span>
        <span className="text-[14px] text-[var(--color-text-muted)] tabular-nums">/ {target}</span>
      </div>
      <div className="mt-[var(--spacing-2)] h-[4px] rounded-full bg-[var(--color-border-stroke)] overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-[var(--duration-medium)]"
          style={{
            width: `${clampedProgress}%`,
            backgroundColor: accentColor ?? "var(--color-accent)",
          }}
        />
      </div>
    </div>
  );
}
